// Mycelial easing vocabulary (from design reference Section 04)
export const EASE = {
  tipExtension: "cubic-bezier(0.25, 0.1, 0.25, 1.0)",   // hero/primary entry
  branching:    "cubic-bezier(0.4, 0.0, 0.2, 1.0)",      // card/secondary entry
  anastomosis:  "cubic-bezier(0.0, 0.0, 0.2, 1.0)",      // connection animations
  remodeling:   "cubic-bezier(0.4, 0.0, 0.6, 1.0)",      // layout shifts
  pruning:      "cubic-bezier(0.4, 0.0, 1.0, 1.0)",      // exit/fade-back
};

// Duration tokens (growth-rate derived)
export const DUR = {
  instant:   "150ms",
  quick:     "250ms",
  moderate:  "500ms",
  deliberate:"800ms",
  ambient:   "2000ms",
};
